<template>
    <img src="/images/icons/coupons-icon.svg" loading="lazy" width="20" height="20" alt="user icon"/>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
